
<div class="row talent-payroll" style="background-color:white;">
  <div class="col-lg-16 ps-0 pe-0">
    <div class="page-container">
      <div class="container-fluid">
        <div class="Row timesheet-dashboard-content" *ngIf="tsSummary && tsSummary.items">
          <ng-container *ngFor="let listItem of  tsSummary.items">
            <div id="row-{{listItem.id}}" class="float-start">
              <timesheet-card [batchSummary]="listItem"
                              [buAccess]="buAccess">
              </timesheet-card>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
